const Title = () => <h1>React World Weather<span style={{display: "block", fontSize: "1.2rem"}}>with TypeScript</span></h1>

export default Title;